'use client';

import { useRef } from 'react';

const DEFAULT_ANIMATION_DELAY_MS = 100;

/**
 * Keeps animation styles disabled for the initial mount period.
 *
 * The deadline is stored in a ref so later renders can enable animations without
 * scheduling a render solely for the deadline.
 */
// oxlint-disable react/refs -- The ref preserves mount state without triggering a render.
export const useAnimationEnabledAfterMount = (delayMs = DEFAULT_ANIMATION_DELAY_MS): boolean => {
    const animationEnabledAtRef = useRef<number | null>(null);

    if (animationEnabledAtRef.current === null) {
        // oxlint-disable-next-line react/purity -- Read once to establish the stable mount deadline.
        animationEnabledAtRef.current = performance.now() + delayMs;
    }

    // oxlint-disable-next-line react/purity -- Read the stable deadline without scheduling a render.
    return performance.now() >= animationEnabledAtRef.current;
};
